import {DialogCompararaisonImageComponent} from './../dialogs/comparaison-images/comparaison-images.component';
import {ChangeDetectionStrategy, Component, Inject, OnInit, ViewChild} from '@angular/core';
import {MatPaginator} from '@angular/material/paginator';
import {MatSort} from '@angular/material/sort';
import {MatTableDataSource} from '@angular/material/table';

import {UtilisateurModel} from '../../models/utilisateur';
import {
  Firestore,
  addDoc,
  collection,
  collectionData,
  deleteDoc,
  doc,
  setDoc,
  updateDoc
} from '@angular/fire/firestore';
import {ProjetModel} from '../../models/projet';
import {MatSnackBar} from '@angular/material/snack-bar';
import {
  Storage,
  deleteObject,
  getDownloadURL,
  listAll,
  ref,
  uploadBytes,
  uploadString
} from '@angular/fire/storage';
import {AuthService} from '../services/auth.service';
import {Router} from '@angular/router';
import {MatDialog} from '@angular/material/dialog';
import {MAT_BOTTOM_SHEET_DATA, MatBottomSheet, MatBottomSheetRef} from '@angular/material/bottom-sheet';
import {HttpClient} from '@angular/common/http';

@Component({
  selector: 'app-projets',
  templateUrl: './projets.component.html',
  styleUrls: ['./projets.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class ProjetsComponent implements OnInit {
  nouveauProjet = new ProjetModel();
  displayedColumns: string[] = ['libelle', 'nbPoteaux', 'zone', 'utilisateur', 'dateCloture', 'actif', 'actions'];
  dataSource = new MatTableDataSource();

  zones = new Array<string>();
  zonesSearch = new Array<string>();

  utilisateurs: any;

  fichierKml: File | null = null;
  fichierOrange: File | null = null;
  fichiersKmlSupplementaires: File[] = [];

  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;
  @ViewChild(MatSort, {static: true}) sort: MatSort;

  regex = /[ `!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]é^éïîôöàâäè/;

  constructor(
    private db: Firestore,
    private snackBar: MatSnackBar,
    private dialog: MatDialog,
    private storage: Storage,
    private authService: AuthService,
    private http: HttpClient,
    private router: Router,
    private bottomSheet: MatBottomSheet) {
  }

  ngOnInit() {
    this.authService.isLoggedIn.subscribe((isLoggedIn) => {
      if (!isLoggedIn) {
        this.router.navigate(['/connexion']);
      }
    });


    collectionData(collection(this.db, 'projets'), {idField: 'id'}).subscribe((datas: any[]) => {
      const zones = datas.map((d) => d.zone);
      this.zones = zones.filter(this.onlyUnique).sort();
      this.zonesSearch = this.zones;
    });

    collectionData(collection(this.db, 'projets'), {idField: 'id'}).subscribe((datas: any[]) => {
      this.dataSource.data = datas
        .filter((data: any) => data.archive === false)
        .map((data: any) => ({
        id: data.id,
        utilisateur: data.utilisateur,
        libelle: data.libelle,
        nbPoteauxSaisis: 0,
        nbPoteaux: data.reprises?.length,
        kml: data.kml,
        zone: data.zone,
        actif: data.actif,
        archive: data.archive,
        dateCloture: data.dateCloture
      }));
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
    });

    collectionData(collection(this.db, 'utilisateurs'), {idField: 'id'}).subscribe((datas: any[]) => {
      this.utilisateurs = datas;
    });
  }

  filterZone() {
    const search = (this.nouveauProjet.zone ?? '').toString().toLowerCase();
    this.zonesSearch = this.zones.filter((x) =>
      (x ?? '').toString().toLowerCase().includes(search)
    );
  }

  nombreReprises(reprises, kml) {
    const body = {
      kml
    };
    this.http.post('https://bbefrance.azurewebsites.net/api/CompteurPoteaux', body).subscribe(value => {
      alert(reprises + ' / ' + value);
    });
  }

  onlyUnique(value, index, self) {
    return self.indexOf(value) === index;
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  archiver(projet) {
    projet.archive = true;
    setDoc(doc(this.db, 'projets', projet.id), projet)
      .then(_ => {
        this.message('Projet archivé avec succès !');
      })
      .catch((error) => {
        console.log(error);
      });
  }

  changerEtat(projet, actif) {
    updateDoc(doc(this.db, 'projets', projet.id), {
      actif,
      dateCloture: new Date()
    })
      .then(_ => {
        if (actif) {
          this.message('Projet ouvert avec succès !');
        } else {
          this.message('Projet fermé avec succès !');
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }

  supprimer(id) {
    if (confirm('En continuant vous supprimerez le projet, les poteaux et les images du projet, si vous voulez juste archiver le projet cliquez sur annuler puis cliquez le bouton rose du projet en question. Confirmez-vous la suppression du projet ?')) {
      deleteDoc(doc(this.db, 'projets', id)).then(_ => {
        this.message('Projets supprimé avec succès !');
      }).catch((error) => {
        console.log(error);
      });
    }
  }

  async valider() {
    this.nouveauProjet.libelle = this.nouveauProjet.libelle.trim();
    if (!this.nouveauProjet.libelle) {
      this.message('Libellé obligatoire !');
    } else if (this.regex.test(this.nouveauProjet.libelle.toLowerCase()) || this.nouveauProjet.libelle.includes(' ')) {
      this.message('Le libellé ne doit pas contenir de caractères spéciaux.');
    } else if (!this.nouveauProjet.zone) {
      this.message('Zone obligatoire !');
    } else if (!this.nouveauProjet.utilisateur) {
      this.message('Utilisateur obligatoire !');
    } else if (!this.fichierKml) {
      this.message('Fichier KML obligatoire !');
    } else {
      this.nouveauProjet.kml = await this.uploadFile(this.fichierKml);

      if (this.fichierOrange) {
        this.nouveauProjet.orangeKmlFile = await this.uploadFile(this.fichierOrange);
      }

      if (this.fichiersKmlSupplementaires.length > 0) {
        this.nouveauProjet.kmlFilesSupplementaires = await Promise.all(
          this.fichiersKmlSupplementaires.map((fichier) => this.uploadFile(fichier))
        );
      }

      addDoc(collection(this.db, 'projets'), JSON.parse(JSON.stringify(this.nouveauProjet)))
        .then(_ => {
          this.message('Projet ajouté avec succès !');
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }

  async uploadFile(file: File) {
    const blobKml = new Blob([file], {type: file.type});
    const fileRef = ref(this.storage, `${this.nouveauProjet.libelle}/${file.name}`);
    await uploadBytes(fileRef, blobKml);
    return getDownloadURL(fileRef);
  }

  onKmlFileChange(event: Event) {
    const input = event.target as HTMLInputElement;
    this.fichierKml = input.files?.[0] ?? null;
  }

  onOrangeFileChange(event: Event) {
    const input = event.target as HTMLInputElement;
    this.fichierOrange = input.files?.[0] ?? null;
  }

  onKmlSupplementairesChange(event: Event) {
    const input = event.target as HTMLInputElement;
    this.fichiersKmlSupplementaires = Array.from(input.files ?? []);
  }

  genererKml(id, libelle) {
    let poteaux = '';
    collectionData(collection(this.db, `projets/${id}/poteaux`)).subscribe((datas: any[]) => {
      poteaux += '<?xml version="1.0" encoding="UTF-8"?>';
      poteaux += '<kml xmlns="http://www.opengis.net/kml/2.2">';
      poteaux += '<Document id="root_doc">';
      poteaux += '<Folder>';
      poteaux += '<name>' + libelle + '</name>';
      datas.forEach(poteau => {
        poteaux += `
          <Placemark>
            <name>${poteau.name}</name>
            <ExtendedData>
              <Data name="TYPE"><value>${poteau.type ?? ''}</value></Data>
              <Data name="nom"><value>${poteau.name ?? ''}</value></Data>
              <Data name="ENVIRONNEMENT"><value>${poteau.environnement ?? ''}</value></Data>
              <Data name="ENVIRONNEMENT_ELECTRIQUE"><value>${poteau.environnementElectrique ?? ''}</value></Data>
              <Data name="TYPE_APPUI"><value>${poteau.typeAppui ?? ''}</value></Data>
              <Data name="hauteur"><value>${poteau.height ?? ''}</value></Data>
              <Data name="MATERIEL"><value>${poteau.materiel ?? ''}</value></Data>
              <Data name="CLASSE"><value>${poteau.className ?? ''}</value></Data>
              <Data name="EFFORT"><value>${poteau.effort ?? ''}</value></Data>
              <Data name="ELAGAGE"><value>${poteau.elagage ?? ''}</value></Data>
              <Data name="ENDOMMAGE"><value>${poteau.damaged ?? ''}</value></Data>
              <Data name="ILLISIBLE"><value>${poteau.illegible ?? ''}</value></Data>
              <Data name="CAUSE"><value>${poteau.cause ?? ''}</value></Data>
              <Data name="DEUX_FILS"><value>${poteau.twoCables ?? ''}</value></Data>
              <Data name="CABLE_VERS_FACADE"><value>${poteau.cableToFacade ?? ''}</value></Data>
              <Data name="MALT"><value>${poteau.malt ?? ''}</value></Data>
              <Data name="RAS_BT"><value>${poteau.rasBt ?? ''}</value></Data>
              <Data name="RAS_FT"><value>${poteau.rasFt ?? ''}</value></Data>
              <Data name="TYPE_SUPP"><value>${poteau.typeSupp ?? ''}</value></Data>
              <Data name="TYPE_SUPP_OK"><value>${poteau.typeSuppOk ?? ''}</value></Data>
              <Data name="PRESENCE_BOITE"><value>${poteau.presenceBoite ?? ''}</value></Data>
              <Data name="FIBRE_SFR"><value>${poteau.fibreSfr ?? ''}</value></Data>
              <Data name="PRESENCE_REHAUSSE"><value>${poteau.presenceRehausse ?? ''}</value></Data>
              <Data name="PRIVE"><value>${poteau.privateState ?? ''}</value></Data>
              <Data name="ADDUCTION"><value>${poteau.adduction ?? ''}</value></Data>
              <Data name="EP"><value>${poteau.ep ?? ''}</value></Data>
              <Data name="ETIQUETTE_JAUNE"><value>${poteau.yellowLabel ?? ''}</value></Data>
              <Data name="ETIQUETTE_ROUGE"><value>${poteau.redLabel ?? ''}</value></Data>
              <Data name="FAMILLE"><value>${poteau.famille ?? ''}</value></Data>
              <Data name="INACCESSIBLE"><value>${poteau.inaccessible ?? ''}</value></Data>
              <Data name="OBSERVATION"><value>${poteau.observation ?? ''}</value></Data>
              <Data name="ACCESSIBILITE_VEHICULE"><value>${poteau.accessibiliteVehicule ?? ''}</value></Data>
              <Data name="CONTROLE_VISUEL"><value>${poteau.controleVisuel ?? ''}</value></Data>
              <Data name="CONTROLE_VERTICALITE"><value>${poteau.controleVerticalite ?? ''}</value></Data>
              <Data name="CONTROLE_FLAMBEMENT"><value>${poteau.controleFlambement ?? ''}</value></Data>
              <Data name="CONTROLE_VOISINAGE_ELEC"><value>${poteau.controleVoisinageElec ?? ''}</value></Data>
              <Data name="CONTROLE_POINTE"><value>${poteau.controlePointe ?? ''}</value></Data>
              <Data name="CONTROLE_SECOUSSE"><value>${poteau.controleSecousse ?? ''}</value></Data>
              <Data name="CONTROLE_PERCUTION"><value>${poteau.controlePercurtion ?? ''}</value></Data>
              <Data name="BON_ETAT"><value>${poteau.bonEtat ?? ''}</value></Data>
              <Data name="PINCE_EA"><value>${poteau.pinceEa ?? ''}</value></Data>
              <Data name="PINCE_ES"><value>${poteau.pinceEs ?? ''}</value></Data>
            </ExtendedData>
            <Point>
              <coordinates>${poteau.location.toString().split(',')[1] + ',' + poteau.location.toString().split(',')[0]}</coordinates>
            </Point>
          </Placemark>
        `;
      });
      poteaux += '</Folder>';
      poteaux += '</Document>';
      poteaux += '</kml>';

      const fichierPoteaux = libelle + '/' + libelle + '-POTEAUX.kml';
      uploadString(ref(this.storage, fichierPoteaux), poteaux).then(() => {
        this.message('KML généré avec succès lancer la synchronisation pour les récuperer !', 5000);
      });
    });

    let liaisons = '';
    collectionData(collection(this.db, `projets/${id}/liaisons`)).subscribe((datas: any[]) => {
      liaisons += '<?xml version="1.0" encoding="UTF-8"?>';
      liaisons += '<kml xmlns="http://www.opengis.net/kml/2.2">';
      liaisons += '<Document id="root_doc">';
      liaisons += '<Folder>';
      liaisons += '<name>' + libelle + '</name>';
      datas.forEach(liaison => {
        liaisons += `
          <Placemark>
            <ExtendedData>
              <Data name="CABLE_A_T1"><value>${liaison.cableAT1 ?? ''}</value></Data>
              <Data name="CABLE_D_T1"><value>${liaison.cableDT1 ?? ''}</value></Data>
              <Data name="HAUTEUR_T1"><value>${liaison.heightT1 ?? ''}</value></Data>
              <Data name="CABLE_A_T2"><value>${liaison.cableAT2 ?? ''}</value></Data>
              <Data name="CABLE_D_T2"><value>${liaison.cableDT2 ?? ''}</value></Data>
              <Data name="HAUTEUR_T2"><value>${liaison.heightT2 ?? ''}</value></Data>
              <Data name="CABLE_A_T3"><value>${liaison.cableAT3 ?? ''}</value></Data>
              <Data name="CABLE_D_T3"><value>${liaison.cableDT3 ?? ''}</value></Data>
              <Data name="HAUTEUR_T3"><value>${liaison.heightT3 ?? ''}</value></Data>
              <Data name="DISTANCE"><value>${liaison.distance ?? ''}</value></Data>
            </ExtendedData>
            <LineString>
              <coordinates>
                ${liaison.postFrom.split(',')[1] + ',' + liaison.postFrom.split(',')[0]} ${liaison.postTo.split(',')[1] + ',' + liaison.postTo.split(',')[0]}
              </coordinates>
            </LineString>
          </Placemark>
        `;
      });
      liaisons += '</Folder>';
      liaisons += '</Document>';
      liaisons += '</kml>';

      const fichierLiaisons = libelle + '/' + libelle + '-LIAISONS.kml';
      uploadString(ref(this.storage, fichierLiaisons), liaisons).then(() => {
        this.message('KML généré avec succès lancer la synchronisation pour les récuperer !', 5000);
      });
    });
  }

  changerTechnicien(projet) {
    this.bottomSheet.open(ChangerTechnicienBottomSheetComponent, {data: {utilisateurs: this.utilisateurs, projet}});
  }

  getUserDisplayName(id) {
    if (!Array.isArray(this.utilisateurs)) {
      return '';
    }
    return this.utilisateurs.find((x) => x?.id === id)?.prenomNom ?? '';
  }


  genererKmlManquants(projet) {
    const poteauxOk = [];

    listAll(ref(this.storage, `${projet.libelle}/images`)).then((res) => {
      res.prefixes.forEach((folderRef) => {
        poteauxOk.push(folderRef.name);
      });
      const body = {
        kml: projet.kml,
        name: projet.libelle,
        folders: poteauxOk
      };
      this.http.post('https://bbefrance.azurewebsites.net/api/PoteauxProjet', body, {responseType: 'blob'}).subscribe(value => {
        this.downLoadFile(value, projet.libelle + '.kml');
      });
    });
  }

  downLoadFile(data: any, fileName) {
    const blob = new Blob([data], {type: 'application/vnd.google-earth.kml+xml'});
    const url = window.URL.createObjectURL(blob);

    const a = document.createElement('a');
    document.body.appendChild(a);
    a.style.display = 'none';
    a.href = url;
    a.download = fileName;
    a.click();
    window.URL.revokeObjectURL(url);
  }

  comparaisonImage(projet) {
    this.dialog.open(DialogCompararaisonImageComponent, {
      width: '650px',
      data: {projet}
    });
  }

  message(message, duration = 3000) {
    this.snackBar.open(message, null, {duration});
  }
}

@Component({
  selector: 'app-changertechnicien-bottomsheet',
  template: `
    <mat-nav-list>
      <a href="#" *ngFor="let u of utilisateurs" mat-list-item (click)="select($event, u.id)">
        <span mat-line>{{ u.prenomNom }}</span>
      </a>
    </mat-nav-list>
  `,
  standalone: false
})
export class ChangerTechnicienBottomSheetComponent {
  projet: ProjetModel;
  utilisateurs: Array<UtilisateurModel>;

  constructor(
    private bottomSheetRef: MatBottomSheetRef<ChangerTechnicienBottomSheetComponent>,
    @Inject(MAT_BOTTOM_SHEET_DATA) public data: any,
    public snackBar: MatSnackBar,
    private db: Firestore) {
    this.projet = data.projet;
    this.utilisateurs = data.utilisateurs;
  }

  select(event: MouseEvent, id: string): void {
    this.bottomSheetRef.dismiss();
    event.preventDefault();

    updateDoc(doc(this.db, 'projets', this.projet.id), {utilisateur: id})
      .then(_ => {
        this.message('Projet modifié avec succès !');
      })
      .catch((error) => {
        console.log(error);
      });
  }

  message(message, duration = 3000) {
    this.snackBar.open(message, null, {duration});
  }
}
